/*
=========================================================
Muse - Vue Ant Design Dashboard - v1.0.0
=========================================================

Product Page: https://www.creative-tim.com/product/vue-ant-design-dashboard
Copyright 2021 Creative Tim (https://www.creative-tim.com)
Coded by Creative Tim

=========================================================
The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. 
*/

import Vue from 'vue'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import App from './App.vue'
import CustomLayout from './layouts/Custom.vue'
import DefaultLayout from './layouts/Default.vue'
import DashboardLayout from './layouts/Dashboard.vue'
import DashboardRTLLayout from './layouts/DashboardRTL.vue'
import router from './router'
import store from './store';
import moment from "moment";
import Vue2Editor from "vue2-editor";
import utils from './utils/index'


//loading
import './utils/loading/loading.scss'
import LoadingPlugin from './utils/loading/loading'
// import './plugins/click-away'

import './scss/app.scss';

Vue.prototype.$moment = moment;
Vue.prototype.$utils = utils;

Vue.use(Antd);
Vue.use(LoadingPlugin);
Vue.use(Vue2Editor);

Vue.config.productionTip = false

// Adding template layouts to the vue components.
Vue.component("layout-custom", CustomLayout);
Vue.component("layout-default", DefaultLayout);
Vue.component("layout-dashboard", DashboardLayout);
Vue.component("layout-dashboard-rtl", DashboardRTLLayout);


/**
 * @description 全局註冊權限驗證
 */
Vue.prototype.$access = (entId) => {
  // eslint-disable-next-line eqeqeq
  return store.state.user.entIdList.some(item => item == entId)
}

Vue.prototype.$resultTry = (res, finallyBackcall) => {
  try {
    res = res || {};
    if (res.code == 0) {
      return true;
    } else {
      if (res.msg) {
        throw new Error(res.msg);
      }
    }
    return false;
  } catch (error) {
    Vue.prototype.$message.error(error.message);
    return false;
  } finally {
    if (finallyBackcall)
      finallyBackcall();
  }
}


new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')